/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

function appData(addTo, appData, siteData) {
  addTo.app = appData
  addTo.app.title = addTo.app.title || siteData.data.title
  addTo.app.siteTitle = siteData.data.title
  addTo.app.buildTime = siteData.buildTime
  addTo.app.pathPrefix = siteData.pathPrefix

  return addTo
}

export default appData
